import Navbar from "./Navbar/NavBar";
import {Button, Card, Col, Layout, Row} from "antd";
import React, {useState} from "react";
import {DownloadOutlined, SettingOutlined} from "@ant-design/icons";
import PdbFormConfiguration from "./Configuration";
import {DEFAULT_CONFIGURATIONS, populateConfigs} from "./Util";

function Download() {
    const [isModalOpen, setModalOpen] = useState(false);
    const [advancedQueryBuilder, setAdvancedQueryBuilder] = useState(DEFAULT_CONFIGURATIONS);

    return (
                <Layout style={{ backgroundColor:'#FFFFFF',minHeight:'100dvh'}}>
                    <div style={{position: 'sticky', top: 0, zIndex: 10000}}>
                        <Navbar/>
                    </div>
                    <Layout.Content style={{display:"flex", flexDirection:"column", backgroundColor:'#FFFFFF' , gap:40}}>
                        <Row  style={{justifyContent:"center"}}>
                            <Col style={{marginTop:'3vh', marginLeft:'3vh'}} span={8}>
                                <Card title="Download PhiSiCal-Checkup offline version:" bordered={true} >
                                    <h4>C++ program (v1.0) to validate amino acid dihedral angle conformations in Proteins</h4>
                                    <div style={{alignItems:'center' , marginTop:'3vh', textAlign:"center"}}>
                                        <Button type="primary" icon={<DownloadOutlined />} size={"large"} href={"https://lcb.infotech.monash.edu/phisical/checkup/download/phisical-checkup_V1.0.zip"}>
                                            Click here to download
                                        </Button>
                                    </div>
                                </Card>
                            </Col>
                        </Row>

                        <Row  style={{justifyContent:"center"}}>
                            <Col style={{marginTop:'3vh', marginLeft:'3vh'}} span={8}>
                                <Card title="Customize conformation evaluation for offline usage:" bordered={true} >
                                    <h4>Create a JSON configuration file to customize the conformations evaluated in the offline version of PhiSiCal-Checkup</h4>
                                    <div style={{alignItems:'center' , marginTop:'3vh', textAlign:"center"}}>
                                        <Button icon={<SettingOutlined />} onClick={()=>{setModalOpen(true)}}>Create configuration file</Button>
                                        <PdbFormConfiguration
                                            isModalOpen={isModalOpen}
                                            setModalOpen={setModalOpen}
                                            advancedQueryBuilder={advancedQueryBuilder}
                                            setAdvancedQueryBuilder={(queryBuilder)=>{
                                                setAdvancedQueryBuilder(queryBuilder)
                                                const configurationList = {configurations: populateConfigs(queryBuilder)}
                                                const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(configurationList));
                                                const downloadAnchorNode = document.createElement('a');
                                                downloadAnchorNode.setAttribute("href",     dataStr);
                                                downloadAnchorNode.setAttribute("download", "configuration.json");
                                                document.body.appendChild(downloadAnchorNode); // required for firefox
                                                downloadAnchorNode.click();
                                                downloadAnchorNode.remove();
                                            }}
                                            OkButtonText = "Download"
                                        />
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Layout.Content>
                    <Layout.Footer style={{width: '100%',textAlign: 'right', zIndex:1000, backgroundColor:"#58B2DC"}}><b>About
                        <a href="https://lcb.infotech.monash.edu/phisical/" target="_blank" rel="noreferrer" style={{color:"#1402f6"}}> 𝜙𝛹𝜒al</a> |
                        <a href="https://lcb.infotech.monash.edu/" target="_blank" rel="noreferrer" style={{color:"#1402f6"}}> LCB Home</a> |v1.0.0 </b>
                    </Layout.Footer>
                </Layout>
    );
}
export default Download;